import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import countries from "../constant/countries";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Logo from "../assets/images/logo.png";

const CountryPage = () => {
  const { country } = useParams();
  const countryData = countries.find((c) => c.name === country);

  useEffect(() => {
  window.scrollTo(0, 0);
}, []);

  const [formData, setFormData] = useState({
    full_name: "",
    nationality: "",
    profession: "",
    email: "",
    phone_number: "",
    city: "",
    country: "",
    country_of_real_estate: "",
    comments: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    toast.success("🎯 Form submitted successfully!");

    // Clear form after submission
    setFormData({
      full_name: "",
      nationality: "",
      profession: "",
      email: "",
      phone_number: "",
      city: "",
      country: "",
      country_of_real_estate: "",
      comments: "",
    });
  };

  if (!countryData) {
    return (
      <div className="text-center mt-24 text-2xl font-bold text-red-600">
        Country not found.
      </div>
    );
  }

  const { flag } = countryData;

  return (
    <>
      {/* Hero Section */}
      <section
        className="relative text-white min-h-[80vh] flex items-center justify-center px-4 sm:px-8"
        style={{
          background: "linear-gradient(90deg, #C9B29B 0%, #A67C52 100%)",
        }}
      >
        <div
          className="absolute inset-0 bg-cover bg-center opacity-25"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1616692474781-9ef0114c15b1?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80')",
          }}
        ></div>

        <div className="relative z-10 text-center max-w-4xl mt-12">
          <div className="flex justify-center">
            <img src={Logo} alt="Logo" className="h-10 md:h-20 w-auto" />
          </div>
          <h1 className="text-xl sm:text-2xl md:text-3xl font-semibold tracking-widest text-[#F3E5AB] font-[Orbitron] uppercase mt-2 mb-2">
            Welcome to the
          </h1>
          <h2 className="text-3xl sm:text-5xl md:text-6xl font-extrabold text-white font-[Orbitron] drop-shadow-lg mb-2">
            TeaWasFantastic,
          </h2>
          <h1 className="text-xl sm:text-2xl md:text-3xl mt-2 font-semibold tracking-wider text-[#FFF5D1] font-[Orbitron] uppercase">
            {country}
          </h1>
        </div>
      </section>

      {/* Form Section */}
      <section className="min-h-screen py-20 px-4 sm:px-10 bg-gradient-to-b from-white to-gray-100 text-gray-800">
        <div className="max-w-4xl mx-auto">
          {flag && (
            <div className="p-4 bg-white rounded-xl shadow-md border flex justify-center mb-10">
              <img
                src={flag}
                alt={country}
                className="w-32 sm:w-40 md:w-52 h-auto rounded-lg shadow-lg"
              />
            </div>
          )}

          <p className="text-center mb-10 text-gray-700 text-lg max-w-2xl mx-auto font-medium">
            Fill the form below to submit your interest in joining the{" "}
            {countryData.name} front.
          </p>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {[
                { name: "full_name", placeholder: "Full Name" },
                { name: "nationality", placeholder: "Nationality" },
                { name: "profession", placeholder: "Profession" },
                { name: "email", placeholder: "Email Address", type: "email" },
                {
                  name: "phone_number",
                  placeholder: "Phone Number",
                  type: "tel",
                },
                { name: "city", placeholder: "City of Residence" },
              ].map(({ name, placeholder, type = "text" }) => (
                <input
                  key={name}
                  type={type}
                  name={name}
                  value={formData[name]}
                  onChange={handleChange}
                  placeholder={placeholder}
                  className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-[#A67C52] transition-shadow shadow-sm hover:shadow-lg text-sm"
                  required
                />
              ))}
            </div>

            <textarea
              name="comments"
              value={formData.comments}
              onChange={handleChange}
              placeholder="Write any comments or additional information"
              rows="4"
              className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-[#A67C52] transition-shadow shadow-sm hover:shadow-lg text-sm"
            ></textarea>

            <div className="text-center pt-4">
              <button
                type="submit"
                className="bg-[#B08968] hover:bg-[#C9B29B] transition-all duration-300 text-white font-semibold px-10 py-3 rounded-xl shadow-xl text-lg"
              >
                🚀 Submit Form
              </button>
            </div>
          </form>
        </div>
      </section>

      {/* Toast Container */}
      <ToastContainer position="top-center" autoClose={3000} />
    </>
  );
};

export default CountryPage;
